import { SelectorData } from 'src/app/utils/selectorDataType';

export enum BusinessStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  IDLE = 'IDLE',
  INVITED = 'INVITED',
}

export enum BusinessStatusColor {
  GREEN = '#008f00',
  YELLOW = '#ffbe00',
  RED = '#b31e1e',
}

export const selectableStatuses: SelectorData[] = [
  { label: 'Active', value: BusinessStatus.ACTIVE },
  { label: 'Disabled', value: BusinessStatus.DISABLED },
  { label: 'Invited', value: BusinessStatus.INVITED },
  { label: 'Idle', value: BusinessStatus.IDLE },
];
